import script from "./plantfx.vue?vue&type=script&setup=true&lang=js"
export * from "./plantfx.vue?vue&type=script&setup=true&lang=js"

import "./plantfx.vue?vue&type=style&index=0&id=6dea34e1&scoped=true&lang=less"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dea34e1"]])

export default __exports__